import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

/**
 * `GridTable`'s default `EmptyElement` renders nothing, so a config with no retry jobs would
 * otherwise leave an unexplained blank body under "Retries history" — see `ScheduledActionsTable`
 * / `EmptyScheduledActions` for the sibling pattern this mirrors.
 */
const EmptyRetriesHistoryComponent = () => {
  return (
    <div css={tw`flex flex-1 flex-col items-center justify-center gap-2 p-10`}>
      <Typography variant="body1" css={tw`text-shades-700`}>
        No retry jobs for this config
      </Typography>
    </div>
  )
}

export const EmptyRetriesHistory = memo(EmptyRetriesHistoryComponent)
